import { Chip, SvgIcon } from "@mui/material";
import type { ComponentType } from "react";
import DhlLogo from "./assets/dhl.svg?react";
import FedexLogo from "./assets/fedEx.svg?react";
import UpsLogo from "./assets/ups.svg?react";

export type ShipmentCarrier = "UPS" | "FedEx" | "DHL" | "Other";

interface CarrierLogoProps {
    carrier: ShipmentCarrier;
}

export function CarrierLogo({ carrier }: Readonly<CarrierLogoProps>) {
    if (carrier === "Other") {
        return (
            <Chip
                label={carrier}
                size="small"
                variant="outlined"
                sx={{
                    userSelect: "none",
                }}
            />
        );
    }

    let LogoComponent: ComponentType | null = null;

    if (carrier === "FedEx") {
        LogoComponent = FedexLogo;
    } else if (carrier === "UPS") {
        LogoComponent = UpsLogo;
    } else if (carrier === "DHL") {
        LogoComponent = DhlLogo;
    }

    if (!LogoComponent) {
        return null;
    }

    // FedEx is a wide wordmark; render it shorter so its footprint is closer to
    // the compact UPS/DHL marks instead of dominating the row.
    const logoHeight = carrier === "FedEx" ? 16 : 24;

    return (
        <SvgIcon
            component={LogoComponent}
            inheritViewBox
            sx={{
                height: logoHeight,
                width: "auto",
                display: "block",
            }}
        />
    );
}